export const ACTION_TYPES = {
  CREATE: 'create',
  READ: 'read'
}
